/** */
import {
  ADD_MANY_BLOGS_TO_STORE,
  ADD_ONE_BLOG_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  LOAD_BLOGS_TO_STORE,
  REM_ONE_BLOG_FROM_STORE
} from '../actions/blog';

export default (state = {}, action) => {
  const { type, payload } = action;
  let previous_state;
  switch (type) {
    case ADD_MANY_BLOGS_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (blogs, blog) => ({
            ...blogs,
            [blog.id]: blog
          }),
          {}
        )
      };
    case ADD_ONE_BLOG_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };
    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (blogs, blog) => ({
            ...blogs,
            [blog.id]: blog
          }),
          {}
        )
      };
    case LOAD_BLOGS_TO_STORE:
      return {
        ...payload.reduce(
          (blogs, blog) => ({
            ...blogs,
            [blog.id]: blog
          }),
          {}
        )
      };
    case REM_ONE_BLOG_FROM_STORE:
      previous_state = { ...state };
      delete previous_state[payload];
      return {
        ...previous_state
      };
    default:
      return state;
  }
};
